// extracted by mini-css-extract-plugin
export default {"ul":"Statistics_ul__phWsY","subTitle":"Statistics_subTitle__+9CTp"};